import { useDrag, useDrop } from 'react-dnd';
import DragIcon from '../../../assets/icons/Drag.svg';
import { useContext } from 'react';
import { FileContext } from '../../../context/FileContext';
import { isSignerEligibleColumn } from '../../../utils/signer-column-eligibility';

const DraggableItem = ({ id, index, moveItem, item }) => {
  const ItemType = 'ITEM';
  const { boardData } = useContext(FileContext);

  const [collect, ref] = useDrag(() => ({
    type: ItemType,
    item: { id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const [, drop] = useDrop({
    accept: ItemType,
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveItem(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  // handle email label if changed from monday board
  const emailColumn = boardData?.columns?.filter((col) =>
    isSignerEligibleColumn(col),
  );
  const getTitle = (id) => {
    if (!emailColumn) return;
    const title = emailColumn?.find((x) => x.id === id)?.title || '';
    return title;
  };

  return (
    <div
      ref={(node) => ref(drop(node))}
      style={{
        padding: '8px',
        border: '1px solid #ccc',
        marginBottom: '8px',
        width: '100%',
        borderRadius: 4,
        cursor: collect.isDragging ? 'grabbing' : 'grab',
        display: 'flex',
        alignItems: 'center',
        columnGap: '10px',
      }}
    >
      <div
        style={{
          width: 16,
          height: 16,
          background: item?.color || 'white',
        }}
      />
      <p style={{ fontSize: '11px', fontFamily: 'Roboto' }}>
        {item.label === 'Me' ? item.label : getTitle(item.emailColumnId)}
      </p>
      <img style={{ marginLeft: 'auto' }} src={DragIcon} alt="close" />
    </div>
  );
};

export default DraggableItem;
